import React from "react";
import { Navbar } from "react-bootstrap";
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useLocation } from 'react-router-dom';

const PAGE_TITLES = {
  '/': 'Dashboard Homepage',
  '/transport': 'Transport & Logistics',
  '/dashboard-analytics': 'Dashboard Analytics',
  '/imaging': 'Diagnostic Imaging',
  '/cost-per-test': 'Cost Per Test',
};

const Header = ({ selectedRoute }) => {
  const { pathname } = useLocation();
  const { user } = useAuthenticator((context) => [context.user]);
  const dashboardList =
    localStorage.getItem('DASHBOARD_LIST_ITEM') ?
      JSON.parse(localStorage.getItem('DASHBOARD_LIST_ITEM')) :
        null;
  const filteredDashboardItem = dashboardList?.filter((item) => item.id === pathname?.split('/')?.[1])?.[0];

  const getPageTitle = () => {
    if (!user) return 'GPLS';
    if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname];
    if (filteredDashboardItem?.name) return filteredDashboardItem.name;
    return 'GPLS';
  };

  return (
    <Navbar
      bg="light"
      className="navbar shadow-sm mb-1 bg-white"
      expand
      style={{ padding: '13px 24px'}}
    >
      <span style={{ fontWeight: '700', fontSize: '24px', color: '#003087', paddingLeft: '10px' }}>
        {getPageTitle()}
      </span>
    </Navbar>
  );
}

export default Header;
